import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notification-system',
  templateUrl: './notification-system.component.html',
  styleUrls: ['./notification-system.component.css']
})
export class NotificationSystemComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
